import { Component, OnDestroy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { CpAgGridService } from '@app/Modules/cp-grid/services/cp-ag-grid-service';
import { HttpService } from '@app/Modules/Shared/Services/http.service';
import { GlobalAppService } from '@app/Modules/Shared/Services/global-app.service';
import { SignalRMaster } from '@app/Modules/Shared/Services/SingnalR.master.service';
import { PmadminService } from '@app/Modules/Shared/Services/pmadmin.service';

@Component({
  selector: 'app-hyperlink-search-new-user',
  templateUrl: './hyperlink-search-new-user.component.html',
  styleUrls: ['./hyperlink-search-new-user.component.scss']
})
export class HyperlinkSearchNewUserComponent implements AgRendererComponent, OnDestroy {

  params: any;
 
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private httpServ: HttpService,
    private gridService: CpAgGridService,
    private appserv: AppService,
    private globalAppService: GlobalAppService,
    private signalRService: SignalRMaster,
    private pmadminServ: PmadminService   ) { }

  ngOnInit() {
  }

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    return true;
  }

  onLinkClick() {
    this.pmadminServ.setUserId(this.params.value);
    this.pmadminServ.openEdit();
    //this.router.navigate([{ outlets: { dialogs: ['editUserAccess', this.params.value] } }], { relativeTo: this.activatedRoute.parent.parent });
  }

  ngOnDestroy() {

  }

}
